import { useAuth0 } from '@auth0/auth0-react';
import Box from '@mui/material/Box';
import Step from '@mui/material/Step';
import StepLabel from '@mui/material/StepLabel';
import Stepper from '@mui/material/Stepper';
import PreSchoolService from 'Lib/API/PreSchool';
import FinanceSetting from 'Lib/API/FinanceSetting/FinanceSetting';
import MyButton from 'components/MyButton';
import { FormikWizard } from 'formik-wizard-form';
import { uploadFile } from 'pages/Auth/Presigned';
import React, { useEffect, useRef, useState } from 'react';
import { toastr } from 'react-redux-toastr';
import { useHistory, useParams } from 'react-router-dom';
import { getOrganizationInfoFromLocalStorage } from 'utils/functions';
import { emailValidation } from 'utils/validation';
import {
  formInformation,
} from '../../ValidationSchema/formsSchema';
import { pricingValidation } from '../../ValidationSchema/formPriceSchema';

import './form.scss';
import CreateForm from './newFormSteps/CreateForm/CreateForm';
import FormInformation from './newFormSteps/FormInformation/FormInformation';
import Pricing from './newFormSteps/Pricing/Pricing';
import NotificationTemplate from './newFormSteps/NotificationTemplate/NotificationTemplate'

const CreateNewForm = () => {
  const orgDetails = getOrganizationInfoFromLocalStorage();

  const [finished, setFinished] = useState(false);
  const { getAccessTokenSilently } = useAuth0();
  const [loading, setLoading] = useState(false);
  const [coverImage, setCoverImage] = useState("");
  const [croppedImage, setCroppedImage] = useState(null);
  const { push } = useHistory();
  const { id: formId } = useParams();
  const formikRef = useRef();

  const requiredFields = [
    {
      "id": "93EF4F7B-E69F-4DC7-94BE-BB5B1793FE88",
      "element": "TextInput",
      "text": "Text Input",
      "required": true,
      "canHaveAnswer": true,
      "canHavePageBreakBefore": true,
      "canHaveAlternateForm": true,
      "canHaveDisplayHorizontal": true,
      "canHaveOptionCorrect": true,
      "canHaveOptionValue": true,
      "canPopulateFromApi": true,
      "field_name": "text_input_DC6632D8-F02F-4ED2-AC46-351DB7B949A4",
      "label": "First Name ",
      "dirty": false
    },
    {
      "id": "869CA6BE-DE41-48CB-89B4-2FC0D9862FC5",
      "element": "TextInput",
      "text": "Text Input",
      "required": true,
      "canHaveAnswer": true,
      "canHavePageBreakBefore": true,
      "canHaveAlternateForm": true,
      "canHaveDisplayHorizontal": true,
      "canHaveOptionCorrect": true,
      "canHaveOptionValue": true,
      "canPopulateFromApi": true,
      "field_name": "text_input_D00A65F9-01A9-4FA8-A132-01E7EF6F8984",
      "label": "Last Name ",
      "dirty": false
    },
    {
      "id": "986AB1B0-19F0-4339-8594-59427982B41D",
      "element": "EmailInput",
      "text": "Email",
      "required": true,
      "canHaveAnswer": true,
      "canHavePageBreakBefore": true,
      "canHaveAlternateForm": true,
      "canHaveDisplayHorizontal": true,
      "canHaveOptionCorrect": true,
      "canHaveOptionValue": true,
      "canPopulateFromApi": true,
      "field_name": "email_input_02B42DD9-B021-4B9A-B0C6-B6FF3B3D8EF2",
      "label": "E-Mail"
    },
    {
      "id": "1E0C45B6-1876-49CC-9FD2-7CF124B14B3C",
      "element": "PhoneNumber",
      "text": "Phone Number",
      "required": false,
      "canHaveAnswer": true,
      "canHavePageBreakBefore": true,
      "canHaveAlternateForm": true,
      "canHaveDisplayHorizontal": true,
      "canHaveOptionCorrect": true,
      "canHaveOptionValue": true,
      "canPopulateFromApi": true,
      "field_name": "phone_input_03841728-EC2E-4965-9B3B-623FABE57B6E",
      "label": "Phone Number"
  }
    
  ]
  const requiredFieldsIds = [
    "93EF4F7B-E69F-4DC7-94BE-BB5B1793FE88",
    "869CA6BE-DE41-48CB-89B4-2FC0D9862FC5",
    "986AB1B0-19F0-4339-8594-59427982B41D",
    "1E0C45B6-1876-49CC-9FD2-7CF124B14B3C"
  ]
  useEffect(() => {
    if (formId) {
      const getForm = async () => {
        try {
          if (formikRef.current) {
            formikRef.current.setFieldValue('loading', true);
          }
          const token = await getAccessTokenSilently();
          const response = await PreSchoolService.getFormById(token, formId);
          const data = response?.result;
          const FormInfo = {
            id: data?._id,
            formName: data?.formName,
            formStartDate: data?.formStartDate,
            formEndDate: data?.formEndDate,
            description: data?.description?.replace(/&lt;/g, '<'),
            allowWaitingList: data?.allowWaitingList,
            allowBillMyAccount: data?.allowBillMyAccount,
            allowNonMembers: !orgDetails?.memberPortal ? true : data?.allowNonMembers,
            alwaysAvailable: data?.alwaysAvailable,
            fillTemplate: data?.fillTemplate || "",
  billMyAccountTemplate: data?.billMyAccountTemplate || "",
  // ⭐ ADD THIS
  emailNotification: data?.emailNotification || [],
            formDetails: {
              maximumCapacity: !data?.formDetails?.infiniteCapacity ? data?.formDetails?.maximumCapacity ?? '' : '',
              infiniteCapacity: data?.formDetails?.infiniteCapacity ?? true,
              contactInfo: {
                firstName: data?.formDetails?.contactInfo?.firstName ?? '',
                lastName: data?.formDetails?.contactInfo?.lastName ?? '',
                email: data?.formDetails?.contactInfo?.email ?? '',
                showEmail: data?.formDetails?.contactInfo?.showEmail ?? false,
              },
              tags: data?.formDetails?.tags || [],
              accountTags: data?.formDetails?.accountTags || [],
              // actionButtonLabel:'Start',//Todo: integrate it with api once available
              actionButtonLabel: data?.buttonLabel ?? 'Start'
            },
            prices: data?.formPricing?.prices?.map((item) => ({
              ...item,
                required: item?.isRequired || false,
                  minAmount:
    item?.type === "openAmount"
      ? item?.minimumOpenAmount ?? ""
      : "",
              limitType: item?.limitType || 'amount',
              variantInfo: item?.variant ? transformVariantInfoToArray(item?.variantInfo) : [],
              type:
              item?.type === 'optional'
                ? 'Optional'
                : item?.type === 'openAmount'
                ? 'Open Amount'
                : item?.type === 'onRegistration'
                  ? 'On Registration'
                  : item?.type === 'noPayment'
                  ? 'No Payment Needed'
                  : 'On Approve',
            })),
            discount: data?.formDiscount,
            formId: data?.form,
            requiredFelids: required_form_field,
            step1Active: 'generalInfo',
            step2Active: 'costInfo',
            step3Active: 'Templates',
            background: data?.background,
            freeForm: data?.freeForm ?? false,
            requiredFormFields: requiredFields,
            requiredFieldsIds: requiredFieldsIds,
          };
          setCroppedImage(data?.background);
          if (formikRef.current) {
            formikRef.current.setValues(FormInfo);
          }
        } catch (error) {
          toastr.error('Error', 'Something went wrong');
        } finally {
          if (formikRef.current) {
            formikRef.current.setFieldValue('loading', false);
          }
        }
      };
      getForm();
    }
  }, [formId, getAccessTokenSilently]);

  const transformVariantInfoToObject = (variantInfo) => {
    const newVariantInfo = {};
    variantInfo.forEach((item) => {
      newVariantInfo[item?.name] = {
        ...(item?.infiniteQuantity ? { 
          infiniteQuantity: item?.infiniteQuantity,
          // amount: +item?.amount,
          forMemberOnly: item?.forMemberOnly,
           openAmount: item?.openAmount || false,
              ...(item?.openAmount
        ? { minimumOpenAmount: +item?.amount }
        : { amount: +item?.amount }),
         } : { 
          quantity: +item?.quantity,
          // amount: +item?.amount,
          forMemberOnly: item?.forMemberOnly,
           openAmount: item?.openAmount || false,
              ...(item?.openAmount
        ? { minimumOpenAmount: +item?.amount }
        : { amount: +item?.amount }),
         }),
      }
    })
    return newVariantInfo;
  }
  const transformVariantInfoToArray = (variantInfo) => {
    const newVariantInfo = [];
    if(!variantInfo || Object.keys(variantInfo).length === 0) return newVariantInfo;
    for (const key in variantInfo) {
      newVariantInfo.push({
        name: key,
        quantity: variantInfo[key]?.quantity || "",
        infiniteQuantity: variantInfo[key]?.infiniteQuantity || false,
        amount: variantInfo[key]?.openAmount ? variantInfo[key]?.minimumOpenAmount : variantInfo[key]?.amount,
        openAmount: variantInfo[key]?.openAmount || false,
        forMemberOnly: variantInfo[key]?.forMemberOnly,
      })
    }
    return newVariantInfo;
  }

  const fetchTemplatePayload = async (id) => {
    if (!id) return undefined;
    try {
      const token = await getAccessTokenSilently();
      const res = await FinanceSetting.getTemplateById(token, id);
      const r = res?.result;
      if (!r) return undefined;
      return { htmlContent: r.htmlContent, jsonContent: r.jsonContent, replyTo: r.replyTo ?? null, useDefault: r.useDefault ?? true, subject: r.subject };
    } catch (_) { return undefined; }
  };

  const resolveTemplatePayloads = async (values) => {
    const [fill, bill] = await Promise.all([
      values?.fillTemplatePayload || fetchTemplatePayload(values?.fillTemplate),
      values?.billMyAccountTemplatePayload || fetchTemplatePayload(values?.billMyAccountTemplate),
    ]);
    return { fill, bill };
  };

  const handleCreateForm = async (values) => {
    const { fill: fillTemplatePayload, bill: billMyAccountTemplatePayload } = await resolveTemplatePayloads(values);
    const data = {
      formName: values?.formName,
      formStartDate: values?.formStartDate,
      formEndDate: values?.formEndDate,
      alwaysAvailable: values?.alwaysAvailable,
      description: values?.description,
      allowWaitingList: values?.allowWaitingList,
      allowBillMyAccount: values?.allowBillMyAccount,
      allowNonMembers: values?.allowNonMembers,
      fillTemplatePayload: fillTemplatePayload || undefined,
      billMyAccountTemplatePayload: billMyAccountTemplatePayload || undefined,
      buttonLabel: values?.formDetails?.actionButtonLabel,
      emailNotification: values?.emailNotification,
      formDetails: {
        ...(!values?.formDetails?.infiniteCapacity ? {maximumCapacity: values?.formDetails?.maximumCapacity} : {}),
        infiniteCapacity: values?.formDetails?.infiniteCapacity,
        contactInfo: {
          firstName: values?.formDetails?.contactInfo?.firstName,
          lastName: values?.formDetails?.contactInfo?.lastName,
          email: values?.formDetails?.contactInfo?.email,
          showEmail: values?.formDetails?.contactInfo?.showEmail || false,
        },
        tags: values?.formDetails?.tags,
        accountTags: values?.formDetails?.accountTags || [],
      },
      formPricing: {
        prices: values?.freeForm ? [] : values?.prices?.map((item) => {
                      const { minAmount,required, ...rest } = item;

          return{
          ...rest,
             minimumOpenAmount:item?.type==='Open Amount'? item.minAmount:undefined,
          isRequired: item?.type === 'Optional' ? item?.required : undefined,
          installmentDetailsTransaction:
  item?.isInstallmentTransaction &&
  item?.installmentDetailsTransaction?.numberOfInstallment
    ? {
        numberOfInstallment: +item?.installmentDetailsTransaction?.numberOfInstallment,
        lastInstallmentDate:
          item?.installmentDetailsTransaction?.lastInstallmentDate || undefined,
      }
    : undefined,
          amount: (item?.type === 'Open Amount' || (item?.type === 'Optional' && item?.variant) || (item?.type === 'On Registration' && item?.variant) || (item?.type === 'No Payment Needed')) ? 0 : +item?.amount,
          type:
          item?.type === 'Optional' ? 'optional' : item?.type === 'Open Amount' ? 'openAmount' : item?.type === 'On Registration'
              ? 'onRegistration'
              : item?.type === 'No Payment Needed'
              ? 'noPayment'
              : 'onApprove',
          ledger: item?.type === 'No Payment Needed' ? undefined : item?.ledger,
          subLedger:
            item?.type === 'No Payment Needed' ? undefined : item?.subLedger,
          tax_deductible: item?.tax_deductible
            ? +item?.tax_deductible
            : undefined,
          chargeDate:
            item?.type === 'On Approve'  ? item?.chargeDate : undefined,
          dueDate: item?.type === 'On Approve' ? item?.dueDate : undefined,
          note: item?.note ? item?.note : undefined,
          split_duration: item?.is_splitted && item?.split_duration ? item?.split_duration : undefined,
          number_of_split: item?.is_splitted && item?.number_of_split ? item?.number_of_split : undefined,
          required_notes: undefined,
          variant: item?.type === "Optional" || item?.type==="On Registration" ? item?.variant : undefined,
          quantity: ((item?.type === "Optional" || item?.type === "Open Amount") && !item?.infiniteQuantity && !item?.variant && item?.limitType !== "checkbox") ? item?.quantity : undefined,
          infiniteQuantity: ((item?.type === "Optional" || item?.type === "Open Amount") && !item?.variant) ? item?.infiniteQuantity : undefined,
          limitType: item?.type === "Optional" ? item?.limitType ? item?.limitType : 'amount' : undefined,
          variantInfo: (item?.type === "Optional"|| item?.type==="On Registration") && item?.variantInfo?.length && item?.variant ? transformVariantInfoToObject(item?.variantInfo) : undefined,
        }}),
          
      },
      formDiscount: values?.freeForm ? [] : values?.discount?.map((item) => ({
        discount_name: item?.discount_name,
        discount_type:
          item?.discount_type === 'Date'
            ? 'date'
            : 'amount',
        price_type: item?.price_type,
        value: item?.value,
        start_date:
          item?.discount_type === 'Date' ? item?.start_date : undefined,
        end_date: item?.discount_type === 'Date' ? item?.end_date : undefined,
        amount: item?.amount,
        forMemberOnly: item?.forMemberOnly,
      })),

      form: values?.formId,
      freeForm: values?.freeForm,
    };
    try {
      setLoading(true);
      const token = await getAccessTokenSilently();
      const newUrl = coverImage
      ? await uploadFile(coverImage, coverImage, token)
      : "";
      if (typeof newUrl.fileName === "string") {
        data.background = newUrl.fileName;
      }
      await PreSchoolService.createNewForm(token, data);
      toastr.success('Success', 'Form created successfully');
      push('/forms');
    } catch (error) {
      toastr.error('Error', error?.data?.message || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };

  const handleUpdateForm = async (values) => {
    const { fill: fillTemplatePayload, bill: billMyAccountTemplatePayload } = await resolveTemplatePayloads(values);
    const data = {
      formName: values?.formName,
      formStartDate: values?.formStartDate,
      formEndDate: values?.formEndDate,
      alwaysAvailable: values?.alwaysAvailable,
      description: values?.description,
      allowWaitingList: values?.allowWaitingList,
      allowBillMyAccount: values?.allowBillMyAccount,
      allowNonMembers: values?.allowNonMembers,
      fillTemplatePayload: fillTemplatePayload || undefined,
      billMyAccountTemplatePayload: billMyAccountTemplatePayload || undefined,
      emailNotification: values?.emailNotification,
      buttonLabel: values?.formDetails?.actionButtonLabel,
      formDetails: {
        ...(!values?.formDetails?.infiniteCapacity ? {maximumCapacity: values?.formDetails?.maximumCapacity} : {}),
        infiniteCapacity: values?.formDetails?.infiniteCapacity,
        contactInfo: {
          firstName: values?.formDetails?.contactInfo?.firstName,
          lastName: values?.formDetails?.contactInfo?.lastName,
          email: values?.formDetails?.contactInfo?.email,
          showEmail: values?.formDetails?.contactInfo?.showEmail || false,
        },
        tags: values?.formDetails?.tags,
        accountTags: values?.formDetails?.accountTags || [],
      },
      formPricing: {
        prices: values?.freeForm ? [] : values?.prices?.map((item) => {
            const { minAmount,required, ...rest } = item;
         return {
          ...rest,
          minimumOpenAmount:item?.type==='Open Amount'? item.minAmount:undefined,
          isRequired: item?.type === 'Optional' ? item?.required : undefined,
          installmentDetailsTransaction:
  item?.isInstallmentTransaction &&
  item?.installmentDetailsTransaction?.numberOfInstallment
    ? {
        numberOfInstallment: +item?.installmentDetailsTransaction?.numberOfInstallment,
        lastInstallmentDate:
          item?.installmentDetailsTransaction?.lastInstallmentDate || undefined,
      }
    : undefined,
          amount: (item?.type === 'Open Amount' || (item?.type === 'Optional' && item?.variant) || (item?.type === 'On Registration' && item?.variant) || (item?.type === 'No Payment Needed')) ? 0 : +item?.amount,
          type:
          item?.type === 'Optional' ? 'optional' : item?.type === 'Open Amount' ? 'openAmount' : item?.type === 'On Registration'
              ? 'onRegistration'
              : item?.type === 'No Payment Needed'
              ? 'noPayment'
              : 'onApprove',
          ledger: item?.type === 'No Payment Needed' ? undefined : item?.ledger,
          subLedger:
            item?.type === 'No Payment Needed' ? undefined : item?.subLedger,
          tax_deductible: item?.tax_deductible
            ? +item?.tax_deductible
            : undefined,
          chargeDate:
            item?.type === 'On Approve' ? item?.chargeDate : undefined,
          dueDate: item?.type === 'On Approve' ? item?.dueDate : undefined,
          note: item?.note ? item?.note : undefined,
          _id: undefined,
          split_duration: item?.is_splitted && item?.split_duration ? item?.split_duration : undefined,
          number_of_split: item?.is_splitted && item?.number_of_split ? item?.number_of_split : undefined,
          required_notes: undefined,
          variant: item?.type === "Optional"||item?.type==="On Registration" ? item?.variant : undefined,
          quantity: ((item?.type === "Optional" || item?.type === "Open Amount") && !item?.infiniteQuantity && !item?.variant && item?.limitType !== "checkbox") ? item?.quantity : undefined,
          infiniteQuantity: ((item?.type === "Optional" || item?.type === "Open Amount") && !item?.variant) ? item?.infiniteQuantity : undefined,
          limitType: item?.type === "Optional" ? item?.limitType ? item?.limitType : 'amount' : undefined,
          variantInfo:  (item?.type === "Optional" || item?.type === "On Registration")  && item?.variantInfo?.length && item?.variant ? transformVariantInfoToObject(item?.variantInfo) : undefined,
        }}),
      },
      formDiscount: values?.freeForm ? [] : values?.discount?.map((item) => ({
        discount_name: item?.discount_name,
        discount_type:
          item?.discount_type === 'Date' || item?.discount_type === 'date'
            ? 'date'
            : 'amount',
        price_type: item?.price_type,
        value: item?.value,
        start_date:
          item?.discount_type === 'Date' || item?.discount_type === 'date'
            ? item?.start_date
            : undefined,
        end_date:
          item?.discount_type === 'Date' || item?.discount_type === 'date'
            ? item?.end_date
            : undefined,
        amount: item?.amount,
        forMemberOnly: item?.forMemberOnly,
      })),
      form: values?.formId,
      freeForm: values?.freeForm,
    };
    try {
      setLoading(true);
      const token = await getAccessTokenSilently();
      const newUrl = coverImage
      ? await uploadFile(coverImage, coverImage, token)
      : "";
      if (typeof newUrl.fileName === "string") {
        data.background = newUrl.fileName;
      }
      await PreSchoolService.updateForm(token, data, formId);
      toastr.success('Success', 'Form updated successfully');
      push('/forms');
    } catch (error) {
      toastr.error('Error', error?.data?.message || 'Something went wrong');
    } finally {
      setLoading(false);
    }
  };




  const handleNextStep = async (values, currentStepIndex, handleNext) => {
    if (currentStepIndex === 0) {
      const errors = await formikRef.current.validateForm();
      if (Object.keys(errors).length > 0) {
        const newTouched = { ...formikRef.current.touched };
        if (errors.formName) newTouched.formName = true;
        if (errors.formStartDate) newTouched.formStartDate = true;
        if (errors.formEndDate) newTouched.formEndDate = true;
        if (errors.formDetails) {
          newTouched.formDetails = { ...(formikRef.current.touched?.formDetails || {}) };
          if (errors.formDetails.actionButtonLabel) newTouched.formDetails.actionButtonLabel = true;
          if (errors.formDetails.maximumCapacity) newTouched.formDetails.maximumCapacity = true;
          if (errors.formDetails.contactInfo) {
            newTouched.formDetails.contactInfo = { ...(formikRef.current.touched?.formDetails?.contactInfo || {}) };
            if (errors.formDetails.contactInfo.firstName) newTouched.formDetails.contactInfo.firstName = true;
            if (errors.formDetails.contactInfo.lastName) newTouched.formDetails.contactInfo.lastName = true;
            if (errors.formDetails.contactInfo.email) newTouched.formDetails.contactInfo.email = true;
          }
        }
        formikRef.current.setTouched(newTouched);
        const missing = [];
        if (errors.formName) missing.push('Form Name');
        if (errors.formStartDate) missing.push('Start Date');
        if (errors.formEndDate) missing.push('Open Until Date');
        if (errors.formDetails?.actionButtonLabel) missing.push('Action Button Label');
        if (errors.formDetails?.maximumCapacity) missing.push('Maximum Limit');
        if (errors.formDetails?.contactInfo?.firstName) missing.push('First Name');
        if (errors.formDetails?.contactInfo?.lastName) missing.push('Last Name');
        if (errors.formDetails?.contactInfo?.email) missing.push('Email');
        toastr.info(
          'Validation',
          missing.length > 0
            ? `Please fill the following required fields: ${missing.join(', ')}`
            : 'Please fill all the mandatory fields'
        );
        return;
      }
    }

    if (currentStepIndex === 1) {
      const errors = await formikRef.current.validateForm();
      // Manually inject variantInfo.amount errors for Tickets/Addons (Yup 0.29 may not propagate them)
      if (!values.freeForm) {
        (values.prices || []).forEach((price, i) => {
          if ((price.type === 'Tickets' || price.type === 'Addons') && price.variant && Array.isArray(price.variantInfo)) {
            price.variantInfo.forEach((item, vi) => {
              const amount = item?.amount;
              if (amount === '' || amount === undefined || amount === null) {
                if (!errors.prices) errors.prices = [];
                if (!errors.prices[i]) errors.prices[i] = {};
                if (!errors.prices[i].variantInfo) errors.prices[i].variantInfo = [];
                if (!errors.prices[i].variantInfo[vi]) errors.prices[i].variantInfo[vi] = {};
                errors.prices[i].variantInfo[vi].amount = 'Required';
              }
            });
          }
        });
      }
      // Check for duplicate discount names
      const discounts = values?.discount || [];
      if (discounts.length > 1) {
        const discountNames = discounts.map(d => d?.discount_name?.trim()?.toLowerCase()).filter(Boolean);
        const hasDuplicateDiscountNames = discountNames.some((name, i) => discountNames.indexOf(name) !== i);
        if (hasDuplicateDiscountNames) {
          const newTouched = { ...formikRef.current.touched };
          newTouched.discount = discounts.map((_, i) => ({
            ...(formikRef.current.touched?.discount?.[i] || {}),
            discount_name: true,
          }));
          formikRef.current.setTouched(newTouched);
          if (!errors.discount) errors.discount = [];
          discounts.forEach((d, i) => {
            const name = d?.discount_name?.trim()?.toLowerCase();
            if (name && discountNames.filter(n => n === name).length > 1) {
              if (!errors.discount[i]) errors.discount[i] = {};
              errors.discount[i].discount_name = 'Discount name already exists';
            }
          });
          formikRef.current.setErrors(errors);
          toastr.info('Validation', 'Discount names must be unique');
          return;
        }
      }

      const hasPriceErrors = Array.isArray(errors?.prices) && errors.prices.some((e) => e && Object.keys(e).length > 0);
      const hasDiscountErrors = Array.isArray(errors?.discount) && errors.discount.some((e) => e && Object.keys(e).length > 0);
      if (hasPriceErrors || hasDiscountErrors) {
        const newTouched = { ...formikRef.current.touched };
        if (hasPriceErrors) {
          newTouched.prices = values.prices.map((price, i) => {
            const existing = formikRef.current.touched?.prices?.[i] || {};
            if (price.type === 'No Payment Needed') return existing;
            const fields = { ...existing, amount: true, minAmount: true, quantity: true, ledger: true };
            if (price.isInstallmentTransaction) fields.installmentDetailsTransaction = { numberOfInstallment: true };
            if (price.variant && Array.isArray(price.variantInfo)) {
              fields.variantInfo = price.variantInfo.map((_, vi) => ({
                ...(formikRef.current.touched?.prices?.[i]?.variantInfo?.[vi] || {}),
                name: true, amount: true, quantity: true,
              }));
            }
            return fields;
          });
        }
        if (hasDiscountErrors) {
          newTouched.discount = (values.discount || []).map((_, i) => ({
            ...(formikRef.current.touched?.discount?.[i] || {}),
            discount_name: true, discount_type: true, price_type: true,
            value: true, amount: true, quantity: true,
            start_date: true, end_date: true,
          }));
        }
        formikRef.current.setTouched(newTouched);
        formikRef.current.setErrors(errors);
        const missing = [];
        if (Array.isArray(errors.prices)) {
          errors.prices.forEach((priceErr, i) => {
            if (!priceErr) return;
            const priceTitle = values.prices?.[i]?.title || `Price ${i + 1}`;
            if (priceErr.amount) missing.push(`${priceTitle} - Amount`);
            if (priceErr.minAmount) missing.push(`${priceTitle} - Min Amount`);
            if (priceErr.quantity) missing.push(`${priceTitle} - Quantity`);
            if (priceErr.ledger) missing.push(`${priceTitle} - Ledger`);
            if (priceErr.installmentDetailsTransaction?.numberOfInstallment) missing.push(`${priceTitle} - Installments`);
            if (Array.isArray(priceErr.variantInfo)) {
              priceErr.variantInfo.forEach((varErr, vi) => {
                if (!varErr) return;
                const varLabel = values.prices?.[i]?.variantInfo?.[vi]?.name || `Variant ${vi + 1}`;
                if (varErr.name) missing.push(`${priceTitle} - Variant ${vi + 1} Name`);
                if (varErr.amount) missing.push(`${priceTitle} - ${varLabel} - Amount`);
                if (varErr.quantity) missing.push(`${priceTitle} - ${varLabel} - Quantity`);
              });
            }
          });
        }
        if (Array.isArray(errors.discount)) {
          errors.discount.forEach((discErr, i) => {
            if (!discErr) return;
            const discLabel = values.discount?.[i]?.discount_name || `Discount ${i + 1}`;
            if (discErr.discount_name) missing.push(`${discLabel} - Name`);
            if (discErr.discount_type) missing.push(`${discLabel} - Type`);
            if (discErr.price_type) missing.push(`${discLabel} - Price Type`);
            if (discErr.value) missing.push(`${discLabel} - Value`);
            if (discErr.amount) missing.push(`${discLabel} - Amount`);
            if (discErr.quantity) missing.push(`${discLabel} - Quantity`);
            if (discErr.start_date) missing.push(`${discLabel} - Start Date`);
            if (discErr.end_date) missing.push(`${discLabel} - End Date`);
          });
        }
        toastr.info(
          'Validation',
          missing.length > 0
            ? `Please fill the following required fields: ${missing.join(', ')}`
            : 'Please fill all the mandatory fields'
        );
        return;
      }

      if (!values?.freeForm) {
        for (const price of values?.prices) {
          if (price?.variant && (!price?.variantInfo?.length || price?.variantInfo?.some(v => !v?.name?.trim()))) {
            const newTouched = { ...formikRef.current.touched };
            newTouched.prices = values.prices.map((p, idx) => ({
              ...(formikRef.current.touched?.prices?.[idx] || {}),
              variantInfo: (p.variantInfo || []).map((_, vi) => ({
                ...(formikRef.current.touched?.prices?.[idx]?.variantInfo?.[vi] || {}),
                name: true, amount: true, quantity: true,
              })),
            }));
            formikRef.current.setTouched(newTouched);
            toastr.info('Validation', `${price?.title || 'Price'} - Please fill all variant details`);
            return;
          }
          if (price.type === 'Optional') {
            if (price?.variant && price?.variantInfo?.length) {
              const names = new Set();
              for (const item of price?.variantInfo) {
                if (names.has(item?.name?.trim())) {
                  toastr.info('Validation', 'Please enter unique variant name');
                  return;
                }
                names.add(item?.name?.trim());
              }
            }
          }
          if (price?.isInstallmentTransaction && !price?.installmentDetailsTransaction?.numberOfInstallment) {
            toastr.info('Validation', 'Please select number of installments');
            return;
          }
        }
        for (const discount of values?.discount) {
          if (discount.discount_type?.toLowerCase() === 'amount') {
            if (!discount?.amount || discount?.amount < 1) {
              toastr.info('Validation', 'Discount amount should be greater than or equal 1');
              return;
            }
          }
        }
      }
    }

    if (currentStepIndex === 3) {
      if (formId) {
        handleUpdateForm(values);
      } else {
        handleCreateForm(values);
      }
    }
    handleNext();
  };

  
  const formSubmitHandler = async () => {
    const formik = formikRef.current;
    let formId = formik.values?.formId || '';
    if (!formik.values?.form) {
      toastr.info('Validation', 'Please add form fields');
      return;
    }
    if (!formik.values?.form_name) {
      toastr.info('Validation', 'Please add form name');
      return;
    }

    const task_data= formik.values?.form?.task_data || [];
    const formData = [
      ...requiredFields,
      ...task_data,
    ]
    setLoading(true);
    const data = {
      form_name: formik.values?.form_name,
      available: formik.values?.save_template_toggle === 'no' ? false : true,
      requiredFelids: formik.values?.requiredFelids,
      task_data: formData,
      ...(!formId ? {type: "online-form"} : {}),
    };
    try {
      const token = await getAccessTokenSilently();
      const response = formId ?  await PreSchoolService.updateFormTemplate(token, data,formId) : await PreSchoolService.createForm(token, data);
      toastr.success('Success', `Form ${formId ? 'updated' : 'created'} successfully`);
      formik.setFieldValue('formId', response?.result?._id);
      formId = response?.result?._id;
    } catch (error) {
      toastr.error('Error', error?.data?.message || 'Something went wrong');
      setLoading(false);
    }

    return formId;
  }


  const required_form_field = [
    {
      canHaveAlternateForm: true,
      canHaveAnswer: true,
      canHaveDisplayHorizontal: true,
      canHaveOptionCorrect: true,
      canHaveOptionValue: true,
      canHavePageBreakBefore: true,
      canPopulateFromApi: true,
      dirty: true,
      element: 'TextInput',
      field_name: 'text_input_06108B97-D7AC-42A5-8167-ECB948331A10',
      group_name: undefined,
      id: '93EF4F7B-E69F-4DC7-94BE-BB5B1793FE88',
      inline: undefined,
      label: 'First Name ',
      required: true,
      showDescription: undefined,
      static: undefined,
      text: 'Text Input',
    },
    {
      canHaveAlternateForm: true,
      canHaveAnswer: true,
      canHaveDisplayHorizontal: true,
      canHaveOptionCorrect: true,
      canHaveOptionValue: true,
      canHavePageBreakBefore: true,
      canPopulateFromApi: true,
      dirty: false,
      element: 'TextInput',
      field_name: 'text_input_2F6A1BAF-2E0C-46BB-AD2E-617C3364D143',
      group_name: undefined,
      id: '869CA6BE-DE41-48CB-89B4-2FC0D9862FC5',
      inline: undefined,
      label: 'Last Name ',
      required: true,
      showDescription: undefined,
      static: undefined,
      text: 'Text Input',
    },
    {
      canHaveAlternateForm: true,
      canHaveAnswer: true,
      canHaveDisplayHorizontal: true,
      canHaveOptionCorrect: true,
      canHaveOptionValue: true,
      canHavePageBreakBefore: true,
      canPopulateFromApi: true,
      dirty: false,
      group_name: undefined,
      inline: undefined,
      required: true,
      showDescription: undefined,
      static: undefined,
      id: "986AB1B0-19F0-4339-8594-59427982B41D",
      element: "EmailInput",
      text: "Email",
      field_name: "email_input_02B42DD9-B021-4B9A-B0C6-B6FF3B3D8EF2",
      label: "E-Mail"
      
    },
    {
      canHaveAlternateForm: true,
      canHaveAnswer: true,
      canHaveDisplayHorizontal: true,
      canHaveOptionCorrect: true,
      canHaveOptionValue: true,
      canHavePageBreakBefore: true,
      canPopulateFromApi: true,
      dirty: false,
      group_name: undefined,
      inline: undefined,
      required: true,
      showDescription: undefined,
      static: undefined,
      id: "1E0C45B6-1876-49CC-9FD2-7CF124B14B3C",
      element: "PhoneNumber",
      text: "Phone Number",
      field_name: "phone_input_03841728-EC2E-4965-9B3B-623FABE57B6E",
      label: "Phone Number"
    },
    
  ];
  const initialValues = {
    formName: '',
    formStartDate: '',
    formEndDate: '',
    alwaysAvailable: false,
    description: '',
    allowWaitingList: false,
    allowBillMyAccount: false,
    allowNonMembers: true,
      fillTemplate: "",
  billMyAccountTemplate: "",
  emailNotification:[],
    formDetails: {
      maximumCapacity: '',
      infiniteCapacity: true,
      contactInfo: {
        firstName: '',
        lastName: '',
        email: '',
        showEmail: false,
      },
      actionButtonLabel:'Start',
      tags: [],
      accountTags: [],
    },
    prices: [
     
    ],
    discount: [],
    discount_value_type: 'fixed_price',
    discount_type: '',
    internalDrawer: {},
    form_name: '',
    save_template_toggle: 'no',
    form: {},
    requiredFelids: required_form_field,
    formId: '',
    step1Active: 'generalInfo',
    step2Active: 'costInfo',
    step3Active: 'Templates',
    background: "",
    freeForm: false,//checking
    requiredFormFields: requiredFields,
    requiredFieldsIds: requiredFieldsIds,
  };




  return (
    <div className="class__container create-event__container">
      <FormikWizard
        innerRef={formikRef}
        initialValues={initialValues}
        onSubmit={(values) => {}}
          validateOnChange={true}
  validateOnBlur={true}
        steps={[
          {
            component: (props) => <FormInformation coverImage={coverImage}
              setCoverImage={setCoverImage}
              setCroppedImage={setCroppedImage}
              croppedImage={croppedImage}
            {...props} />,
            validationSchema: formInformation,
          },
          {
            component: Pricing,
            validationSchema: pricingValidation,
          },
          {
            component: CreateForm,
          },
          {
            component: NotificationTemplate,
          },
        ]}
      >
        
        {({
          values,
          errors,
          touched,
          isSubmitting,
          setFieldValue,
          currentStepIndex,
          renderComponent,
          handlePrev,
          handleNext,
          isNextDisabled,
          isPrevDisabled,
          handleSubmit,
          ...props
        }) => (
          <form onSubmit={handleSubmit}>
            <div className="top_section">
              <div className="header__title">{formId ? "Edit Form" : "New Form"}</div>
              <div className="class__steps">
                <Stepper activeStep={currentStepIndex}>
                  <Step completed={currentStepIndex > 0} className="step">
                    <StepLabel className="step-label">
                      Form Information
                    </StepLabel>
                  </Step>
                  <Step completed={currentStepIndex > 1}>
                    <StepLabel>Pricing</StepLabel>
                  </Step>
                    <Step completed={currentStepIndex > 2}>
                    <StepLabel> Create Form</StepLabel>
                  </Step>
                  <Step completed={currentStepIndex > 3}>
                    <StepLabel>Notifications</StepLabel>
                  </Step>
                </Stepper>
              </div>
              <div className="action__section">
                <div className="action__buttons d-flex">
                  <MyButton
                    content={currentStepIndex === 0 ? 'Cancel' : 'Previous'}
                    onClick={() => {
                      if (currentStepIndex === 0) {
                        push('/forms');
                      }
                      else {
                        handlePrev();
                      }
                    }}
                    style={{
                      marginRight: '1rem',
                      borderRadius: '0',
                      color: '#565656',
                      height: '39px',
                      width: '113px',
                      backgroundColor: '#fff',
                    }}
                  />
                  <MyButton
                    content={
                      currentStepIndex === 3 ? (
                        <span>
                          Save
                          {loading && (
                            <span className="ml-3 spinner spinner-gray"></span>
                          )}
                        </span>
                      ) : (
                        'Continue'
                      )
                    }
                    onClick={() =>
                      handleNextStep(values, currentStepIndex, handleNext)
                    }
                    disabled={loading}
                    style={{
                      width: '121px',
                      height: '36px',
                    }}
                  />
                </div>
              </div>
            </div>
            <Box>{renderComponent()}</Box>
          </form>
        )}
      </FormikWizard>
    </div>
  );
};

export default CreateNewForm;
